import axios from "axios";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import { LOGOUT } from "@/core/services/store/auth.module";
import Vue from "vue";
import { ir } from "./check_domain_ir";

const coreApi2 =
  Vue.prototype.$coreApi2 || ir("https://api.terminalads.com/api");
const payamak_land = ir("https://sms-api.terminalads.com");
const coreland = ir("https://core-api.terminalads.com");
const coreSecret = process.env.VUE_APP_CORE_SECRET;
const robotLandBack = ir(process.env.VUE_APP_RobatLandBack);
const infolandBack = ir(process.env.VUE_APP_Infoland);
const sarveLand = Vue.prototype.$sarveLand;
const sarveLandFront = Vue.prototype.$sarveLandFront;

function checkToken(token) {
  if (window.location.href.includes("assistantchat")) {
    return null;
  }
  axios
    .get(`${sarveLand}/api/user`, {
      headers: {
        secret: coreSecret,
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem("user_info", JSON.stringify(res.data));
        // this.$router.push({name: 'dashboard'})
      }
    })
    .catch(({ response }) => {
      if (response.status === 401) {
        this.$store
          .dispatch(LOGOUT)
          .then(() => window.location.replace(`${sarveLandFront}`));
      }
    });
}

function saveToken(token) {
  localStorage.setItem("id_token", token);
  this.$router.push("/dashboard");
}

function header() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function robotHeader() {
  return {
    Authorization: JwtService.getToken() ? JwtService.getToken() : null,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function coreHeader() {
  return {
    Authorization: JwtService.getToken()
      ? `Bearer ${JwtService.getToken()}`
      : null,
    secret: coreSecret,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Headers": "*",
    "Content-Type": "application/json",
  };
}

function requestApiGet(uri, queries = {}, serializer = null) {
  return axios.get(`${payamak_land + "/api"}/${uri}`, {
    headers: this.header(),
    params: queries,
    paramsSerializer: serializer,
  });
}

function request_ApiGet(uri, queries = {}) {
  return axios.get(`${coreland + "/api"}/${uri}`, {
    headers: this.header(),
    params: queries,
  });
}

function requestApiGetCore(uri, queries = {}) {
  return axios.get(`${coreland + "/api"}/${uri}`, {
    headers: this.coreHeader(),
    params: queries,
  });
}

function requestApiPostCore(uri, data = {}) {
  return axios.post(`${coreland + "/api"}/${uri}`, data, {
    headers: this.coreHeader(),
  });
}

function requestApiPost(uri, data = {}) {
  return axios.post(`${payamak_land + "/api"}/${uri}`, data, {
    headers: this.header(),
  });
}

function requestApiPostLogin(uri, data = {}) {
  return axios.post(`${payamak_land + "/api"}/${uri}`, data);
}

function requestApiPut(uri, data = {}, queries = {}) {
  return axios.put(`${payamak_land + "/api"}/${uri}`, data, {
    headers: this.header(),
    params: queries,
  });
}

function requestApiDelete(uri, queries = {}) {
  return axios.delete(`${payamak_land + "/api"}/${uri}`, {
    headers: this.header(),
    params: queries,
  });
}

function requestApiGetRobot(uri, queries = {}) {
  return axios.get(`${robotLandBack + "/api"}/${uri}`, {
    headers: this.robotHeader(),
  });
}

function requestApiPostRobot(uri, data = {}, queries = {}) {
  return axios.post(`${robotLandBack + "/api"}/${uri}`, data, {
    headers: this.robotHeader(),
    params: queries,
  });
}

function requestApiGetInfo(uri, queries = {}) {
  return axios.get(`${infolandBack + "/api"}/${uri}`, {
    headers: this.coreHeader(),
    params: queries,
  });
}

export default {
  axios,
  saveToken,
  checkToken,
  robotHeader,
  header,
  coreHeader,
  requestApiGet,
  requestApiPost,
  requestApiPostCore,
  requestApiPostLogin,
  requestApiPut,
  requestApiDelete,
  request_ApiGet,
  requestApiGetCore,
  requestApiGetRobot,
  requestApiPostRobot,
  requestApiGetInfo,
};
